import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@material-ui/core';
import {
  ExitTransitionPlaceholder,
  Inline,
  LightDark,
  Stack,
} from '@superdispatch/ui';
import { Button, TextBox } from '@superdispatch/ui-lab';
import {
  UnverifiedWarning,
  UnverifiedWarningDarkIcon,
} from 'shared/icons/UnverifiedWarning';

interface PostingUnverifiedShipperConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  notes: string | null | undefined;
}

function ConfirmationDialogContent({
  onClose,
  onConfirm,
  notes,
}: PostingUnverifiedShipperConfirmationDialogProps) {
  return (
    <>
      <DialogContent>
        <Stack space="large" align="center">
          <LightDark
            light={<UnverifiedWarning />}
            dark={<UnverifiedWarningDarkIcon />}
          />
          <Stack space="small">
            <Typography align="center" variant="h2">
              This Shipper is Unverified
            </Typography>
            <Typography>
              You are requesting a load from a Shipper that is not verified on
              Super Dispatch.
              <br /> We recommend taking additional steps to vet the
              Shipper&apos;s legal documents.
            </Typography>
            {notes && (
              <Typography>
                <TextBox variant="body-semibold" color="secondary">
                  Notes:
                </TextBox>{' '}
                {notes}
              </Typography>
            )}
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack align="center">
          <Inline>
            <Button variant="neutral" onClick={onConfirm}>
              I understand the Risks
            </Button>
            <Button autoFocus={true} onClick={onClose}>
              Cancel
            </Button>
          </Inline>
        </Stack>
      </DialogActions>
    </>
  );
}

export function PostingUnverifiedShipperConfirmationDialog(
  props: PostingUnverifiedShipperConfirmationDialogProps,
) {
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      maxWidth="sm"
      fullWidth={true}
    >
      <ExitTransitionPlaceholder in={props.open}>
        {props.open && <ConfirmationDialogContent {...props} />}
      </ExitTransitionPlaceholder>
    </Dialog>
  );
}
